import { useMutation } from '@tanstack/react-query'

import { axios } from '@apps-common/lib'
import { toastError, toastSuccess } from '@apps-common/lib/toast'
import { IUnitTaskGroupModel } from '@apps-common/types/portal/unit-tasks'

export const deleteUnitTaskGroup = async (model: IUnitTaskGroupModel): Promise<boolean> =>
  axios.delete(`/management/UnitProgramTask/DeleteTaskGroup?id=${model.id}`).then((res) => res?.data?.data)

type Props = {
  model: IUnitTaskGroupModel
}

export const useManagementDeleteUnitTaskGroup = (notify?: boolean, onSuccess?: (data: boolean) => void) =>
  useMutation({
    mutationKey: ['deleteUnitTaskGroup'],
    mutationFn: ({ model }: Props) => deleteUnitTaskGroup(model),
    onSuccess: (data) => {
      if (onSuccess) {
        onSuccess(data)
      }
      if (notify) {
        toastSuccess('Deleted task.')
      }
    },
    onError: () => {
      if (notify) {
        toastError('Failed to delete task. Cannot delete tasks if any devices have been processed. Please archive.')
      }
    },
    throwOnError: false
  })
